import axios from 'axios';
import { API_URL } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: token ? `Bearer ${token}` : '' };
};

const unwrapError = (error, fallback) => (
  error?.response?.data?.error || error?.message || fallback
);

export const fetchAdminNews = async () => {
  const response = await axios.get(`${API_URL}/admin/news`, { headers: authHeaders() });
  return Array.isArray(response.data) ? response.data : [];
};

export const createAdminNews = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/admin/news`, payload, { headers: authHeaders() });
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to add news'));
  }
};

export const updateAdminNews = async (id, payload) => {
  try {
    const response = await axios.put(`${API_URL}/admin/news/${id}`, payload, { headers: authHeaders() });
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to update news'));
  }
};

export const deleteAdminNews = async (id) => {
  try {
    await axios.delete(`${API_URL}/admin/news/${id}`, { headers: authHeaders() });
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to delete news'));
  }
};
